import React, { useState } from 'react';
import './LoadingSkeleton.scss';
import {
    AccountsLoadingCard,
    ExternalAccountsLoadingCard,
    PRRCard,
    AssetAllocationCard,
    SummitCard,
    AccountsPageHeaderSkeleton,
    AccountsPageSelectorsSkeleton,
    AccountsGridSkeleton,
    WorkplaceRetirementGridSkeleton,
    FactSetSkeleton
} from './LoadingSkeletonSupport';
import { CSSTransition } from 'react-transition-group';
import { Shimmer } from '@trp-ii-ii-component-library/ii-components';

export const BalanceBarLoadingSkeleton = ({ isActive = true }) => {
  const [isLoading, setIsLoading] = useState(isActive);
  return (
    <CSSTransition
      in={isActive}
      timeout={750}
      onExited={() => setIsLoading(false)}
      classNames="balance-bar-skeleton">
      <div className="balance-bar-skeleton-container">
        {isLoading && (
          <div>
            <Shimmer
              className="balance-bar-skeleton-container shimmer"
              y={200}
              x={'100%'}
            />
          </div>
        )}
      </div>
    </CSSTransition>
  );
};

export const DashboardLoadingSkeleton = ({ isActive = true }) => {
  const [isLoading, setIsLoading] = useState(isActive);

  return (
    <CSSTransition
      in={isActive}
      timeout={650}
      onExited={() => setIsLoading(false)}
      classNames={`dashboard-skeleton`}>
      <div className={`dashboard-loading-skeleton-container`}>
        {isLoading && (
          <div className="dashboard-top-group-skeleton">
            <div className="dashboard-main-skeleton">
              <AccountsLoadingCard />
              <ExternalAccountsLoadingCard />
            </div>
            <div className="dashboard-cards-skeleton">
              <PRRCard />
              <AssetAllocationCard />
              <SummitCard />
            </div>
          </div>
        )}
      </div>
    </CSSTransition>
  );
};

export const AccountsPageLoadingSkeleton = ({ isActive = true }) => {
    const [isLoading, setIsLoading] = useState(isActive);

    return (
        <CSSTransition
            in={isActive}
            timeout={650}
            onExited={() => setIsLoading(false)}
            classNames={`accounts-skeleton`}>
            <div className={`accounts-loading-skeleton-container`}>
                {isLoading && (
                    <div className="accounts-grid-container-skeleton">
                    <div className="account-page-header-skeleton">
                        <AccountsPageHeaderSkeleton/>
                        <AccountsPageSelectorsSkeleton/>
                    </div>
                        <AccountsGridSkeleton/>
                        <WorkplaceRetirementGridSkeleton/>
                        <FactSetSkeleton/>
                    </div>
                )}
            </div>
        </CSSTransition>
    );
};

export const FooterLoadingSkeleton = () => <div className="footer-skeleton" />;
